<script>
  import Layout from '@/router/layouts/main';
  import appConfig from '@/app.config';
  const numeral = require('numeral');
  import PageHeader from '@/components/page-header';

  import { mapGetters } from 'vuex';

  export default {
    page: {
      title: 'Quản Lý Đầu Tư',
      meta: [{ name: 'Quản Lý Đầu Tư', content: appConfig.description }],
    },
    components: { Layout, PageHeader },
    data() {
      return {
        title: 'Quản Lý Đầu Tư',
        items: [
          {
            text: 'Hệ Thống',
            href: '/',
          },
          {
            text: 'Quản Lý Đầu Tư',
            active: true,
          },
        ],
      };
    },
    methods: {
      getTotalVolume({ vnd, usd }) {
        const totalUSD = parseFloat(usd) * parseFloat(this.Rate[10]);
        const totalVND = parseFloat(vnd);
        const volume = this.TruncateToDecimals(totalVND + totalUSD, '', 3);
        return volume;
      },
      TruncateToDecimals2(num, type, dec = 2) {
        //   if (!dec) dec = 2;
        const numberFormat = parseFloat(num.toFixed(10));
        const d = numberFormat.toString().split('.');
        if (type == 1) {
          return `${numeral(d[0]).format(0, 0)}`;
        }
        return `${numeral(d[0]).format(0, 0)}${
          d[1] ? `.${d[1].slice(0, dec)}` : ''
        }`;
      },
      getClass(status) {
        if (status === 1) {
          return {
            class: 'text-success',
            text: 'Thành Công',
          };
        }
        if (status === -1) {
          return {
            class: 'text-danger',
            text: 'Đã Huỷ',
          };
        }
        if (status === -2) {
          return {
            class: 'text-danger',
            text: 'Rút Vốn',
          };
        }
        return {
          class: 'text-warning',
          text: 'Đang Tiến Hành',
        };
      },
    },
    computed: {
      ...mapGetters({
        UserInfo: 'user/UserInfo',
        Coin: 'wallet/Coin',
        Rate: 'wallet/Rate',
        Balance: 'wallet/Balance',
        Statistical: 'dashboard/Statistical',
        Project: 'investment/ProjectInvestment',
      }),
      profit() {
        const { balance_pending_profit, total_interest } = this.Statistical;
        const pendingUSD =
          parseFloat(balance_pending_profit.totalUSD) *
          parseFloat(this.Rate[10]);
        const pendingVND = parseFloat(balance_pending_profit.totalVND);
        const Balance = this.TruncateToDecimals(pendingUSD + pendingVND, '', 3);

        const receivedUSD =
          parseFloat(total_interest.totalUSD) * parseFloat(this.Rate[10]);
        const receivedVND = parseFloat(total_interest.totalVND);
        const totalReceived = this.TruncateToDecimals(
          receivedVND + receivedUSD,
          '',
          3
        );

        return {
          balance: Balance,
          received: totalReceived,
        };
      },
      fields() {
        return [
          {
            key: 'project_name',
            sortable: false,
            label: this.$t('dashboard.table.name'),
            class: 'text-center align-middle',
          },
          {
            key: 'total_inves_project',
            sortable: false,
            label: this.$t('dashboard.table.investment'),
            class: 'text-center align-middle',
          },
          {
            key: 'profit_received',
            sortable: false,
            label: this.$t('dashboard.table.profit_received'),
            class: 'text-center align-middle',
          },
          {
            key: 'profit_today',
            sortable: false,
            label: this.$t('dashboard.table.day_profit'),
            class: 'text-center align-middle',
          },
          {
            key: 'total_expected_profit',
            sortable: false,
            label: this.$t('dashboard.table.total_profit'),
            class: 'text-center align-middle',
          },
          {
            key: 'investment_Status',
            sortable: false,
            label: this.$t('dashboard.table.status'),
            class: 'text-center align-middle',
          },

          {
            key: 'project_id',
            sortable: false,
            label: '',
            class: 'text-center align-middle',
          },
        ];
      },
      total_expected_profit() {
        let total = 0;
        if (this.Project && this.Project.list) {
          for (let i = 0; i < this.Project.list.length; i++) {
            total += +this.Project.list[i].total_expected_profit;
          }
        }
        return total;
      },
    },
    created() {
      this.$store.dispatch('dashboard/req_getStatistical');
      this.$store.dispatch('investment/req_getListProjectInvest');
    },
  };
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-container class="manager-investment">
      <b-row>
        <b-col cols="12">
          <div class="box-balance">
            <div class="box-title text-warning">
              Thống Kê Đầu Tư
            </div>
            <div class="box-body">
              <div class="box-main-balance">
                <div class="name text-warning">
                  Tổng Đầu Tư
                </div>
                <div
                  class="amount"
                  v-if="Statistical && Statistical.total_invested"
                >
                  {{
                    getTotalVolume({
                      usd: Statistical.total_invested.total_invested_usd,
                      vnd: Statistical.total_invested.total_invested_vnd,
                    }) || 0
                  }}
                  VND
                </div>
              </div>
              <div class="box-main-received">
                <div class="name text-warning">
                  Tổng Doanh Thu Đã Nhận
                </div>
                <div class="amount">{{ profit.received || 0 }} VND</div>
              </div>
              <div class="box-main-received" v-if="false">
                <div class="name text-warning">
                  Tổng Doanh Thu Dự Kiến
                </div>
                <div class="amount">
                  {{ TruncateToDecimals2(+total_expected_profit) || 0 }} VND
                </div>
              </div>
              <div class="box-main-received">
                <div class="name text-warning">
                  Tổng Dự Án Đã Đầu Tư
                </div>
                <div class="amount">
                  {{ Statistical.number_projects_invested || 0 }} Dự Án
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="box-investing">
            <div class="box-title">
              {{ $t('dashboard.list_investing') }}
            </div>
            <div class="box-body">
              <div class="table-reponsive">
                <b-table striped hover :items="Project.list" :fields="fields">
                  <template #cell(profit_received)="data">
                    {{ data.item.profit_received.profit_vnd }}
                  </template>
                  <template #cell(investment_Status)="data">
                    <p
                      class="mb-0"
                      :class="getClass(data.item.investment_Status).class"
                    >
                      {{ getClass(data.item.investment_Status).text }}
                    </p>
                  </template>
                  <template #cell(project_id)="data">
                    <router-link
                      class="btn btn-gradient-outline-2  my-2 mx-1"
                      :to="{
                        name: 'ProjectDetail',
                        params: { slug: data.item.project_slug },
                      }"
                    >
                      Chi Tiết
                    </router-link>
                    <a
                      class="btn btn-gradient-outline-1 my-2 mx-1"
                      :href="data.item.url"
                      v-if="data.item.project_status == 1"
                      target="_blank"
                    >
                      Xem hợp đồng
                    </a>
                  </template>
                  <template #cell(total_expected_profit)="data">
                    {{ TruncateToDecimals2(data.item.total_expected_profit) }}
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <!-- end row -->
  </Layout>
</template>
<style lang="scss">
  .manager-investment {
    .box-balance {
      margin-bottom: 20px;
      border: none;
      box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.48);
      border-radius: 15px;
      background: url('~@/assets/images/mockup/7.png'),
        linear-gradient(to bottom, #008cff, #003395);
      min-height: 200px;
      width: 100%;
      max-width: 800px;
      margin: 10px auto;
      border: 2px solid #00389b;
      // background-image: ;
      background-position: center;
      background-repeat: no-repeat;
      background-size: contain;
      position: relative;
      @media (max-width: 1320px) {
        &::before {
          position: absolute;
          z-index: 2;
          content: '';
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          border-radius: 15px;
          background-color: rgba(0, 0, 0, 0.48);
        }
      }
      .box-title {
        padding: 15px 15px 5px;
        font-size: 1.6em;
        color: #000;
        text-align: center;
        font-weight: 600;
        position: relative;
        z-index: 2;
      }
      .box-body {
        padding: 15px 35px;
        max-width: 600px;
        margin: auto;

        .box-main-balance,
        .box-main-received {
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.2em;
          .name {
            margin: 10px 0;
            position: relative;
            z-index: 2;
          }
          .amount {
            margin: 10px 0;
            color: #ffffff;
            position: relative;
            z-index: 2;
          }
        }
      }
    }
    .box-investing {
      margin-top: 50px;
      margin-bottom: 20px;
      .box-title {
        padding: 15px 15px 5px;
        font-size: 1.6em;
        color: #000;
        text-align: left;
        font-weight: 600;
        margin-bottom: 10px;
        text-transform: uppercase;
      }
      .box-body {
        padding: 10px 0px;
        border: none;
        box-shadow: 0 0.75rem 1.5rem rgb(0, 0, 0, 0.48);
        border-radius: 15px;
        background: linear-gradient(to bottom, #008cff, #003395);
        min-height: 200px;
        width: 100%;
        border: 2px solid #00389b;
        table {
          thead {
            color: red;
            tr {
              th {
                color: #fff;
                font-size: 1.2em;
              }
            }
          }
          tbody {
            tr {
              td {
                font-size: 1.1em;
                padding: 10px 0.75rem;
              }
            }
          }
        }
      }
    }
  }
</style>
